import React, { useState, useEffect } from 'react';
import { FaTelegramPlane } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function TelegramModal({modalClosed, affiliate_manager}){

    const dismissHandler = () => {               
        const authtoken = localStorage.getItem('mb-auth-token');

        fetch(`${process.env.REACT_APP_API_URL}/announcements/dismiss/telegram`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-app-token': authtoken
            }
        })
            .then(res => res.json())
            .then(result => {
               modalClosed()
            })
            .catch(error => {
                console.log(error.message)
            });
    }

    return (
        <div>
            <div className="modal-header">
                <h6 className="modal-title"><strong>Bye Skype, Hello Telegram!</strong></h6>
                <button type="button" className="close" onClick={modalClosed}>
                    <span aria-hidden="true">x</span>
                </button>
            </div>
            <div className="modal-body">
                <div>
                    <p>We will be switching over to Telegram as our primary communication channel.</p>                        
                    <p>You can stay connected to <strong>{affiliate_manager.name}</strong> by clicking the link below, or by scanning the QR code with the Telegram app on your mobile device.</p>
                    <p>Once your Telegram account is set up, please update your handle in your <Link to='/settings'>MaxBounty account settings</Link>.</p>
                    <div className="text-center m-3"><a target="_blank" rel="noopener noreferrer" className="btn btn-light border text-primary" href={`https://t.me/${affiliate_manager.im_handle}`}><FaTelegramPlane size={20} style={{ paddingRight: "5px" }} />{affiliate_manager.im_handle}</a></div>
                    <div style={{margin: 'auto', maxWidth: '300px'}}>
                        <img className="w-100 rounded" src={`${affiliate_manager.telegram_qr_code}`} alt="Telegram Code" />
                    </div>
                </div>
                <div className="text-center">                  
                    <button className="btn btn-sm btn-warning mt-3" onClick={dismissHandler}>Dismiss</button>
                </div>
            </div>
        </div>
    )
}